import SubmitButton from '@/components/forms/SubmitButton'
import TextInput from '@/components/forms/TextInput'
import {Dispatch, ReactElement, SetStateAction, use, useRef} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {PhoneNumberUtil, PhoneNumberFormat} from 'google-libphonenumber'
import {event} from 'nextjs-google-analytics'
import {Fragment, useState} from 'react'
import React from 'react'
import {
  Formik,
  Form,
  Field,
  FormikHelpers,
  useFormikContext,
  getIn,
} from 'formik'
import {useRouter} from 'next/router'
import toast from 'react-hot-toast'
import CustomToast from '@/components/CustomToast'
import {RegisterSchema, RegisterValues} from '../../../forms/Register'
import {useMutation} from 'react-query'
import PhoneInput from '../../forms/PhoneInput'
import {Registeration, ResendVerification, ResendVerificationEmail} from '@/services/api/auth'
import Verifications from '../Verifications'
import {AnimatePresence, motion} from 'framer-motion'
import BackButton from '../../BackButton'
import * as fbq from '@/services/fbpixel'
import useAuth from '@/hooks/useAuth'
import { VerificationData } from '@/types'
import { AnyPtrRecord } from 'dns'
import { useTranslation } from 'next-i18next'
import { track } from '@/lib/tracker'

interface RegisterViewProps {
    currentView: string
    headingNumber: string | null
    shouldVerify: boolean
    setShouldVerify: React.Dispatch<React.SetStateAction<boolean>>
    verificationData: VerificationData | undefined
    setVerificationData: React.Dispatch<React.SetStateAction<VerificationData | undefined>>
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    VerificationError: any
    setVerificaitonError: React.Dispatch<React.SetStateAction<any>>
    setVerificationError: any
    isOpen: boolean
    setCurrentView: any
    postLoginCallBack: any
    setPortLoginCallBack: any
    productType: any
    setProductType: any
    executePostLoginCallback: () => void
    onButtonClick: (e: React.MouseEvent, action: () => void) => void
    showButton: boolean
    setShowButton: React.Dispatch<React.SetStateAction<boolean>>
}

const RegisterView = (
    {
        currentView,
        headingNumber,
        verificationData,
        shouldVerify,
        setShouldVerify,
        setIsOpen,
        setVerificationData,
        VerificationError,
        setVerificaitonError,
        setVerificationError,
        isOpen,
        setCurrentView,
        postLoginCallBack,
        setPortLoginCallBack,
        productType,
        setProductType,
        executePostLoginCallback,
        onButtonClick,
        showButton,
        setShowButton
    }: RegisterViewProps
) => {
    const { login, isLoading } = useAuth('none')
    const mutation = useMutation(Registeration)
    const {t: tAlerts} = useTranslation('alerts');
    
      const ResendMutation = useMutation(ResendVerification)
      const ResendEmailMutation = useMutation(ResendVerificationEmail)
      
      const handleVerification = (
        phone: string,
        country_code: string,
        actions: FormikHelpers<RegisterValues>,
      ) => {
        ResendMutation.mutate(
          {number: phone, country_code},
          {
            onSuccess() {
              toast.custom((t) => <CustomToast t={t} message={tAlerts('validation_code')} type="success" />, {
                duration: 4000,
              });
              actions.resetForm()
              setShouldVerify(true);
              setShowButton(false);
            },
            onError(error: any) {
              toast.custom((t) => <CustomToast t={t} message={error.response.data.message} type="error" />, {
                duration: 4000,
                id: 'Validation Error'
              });
            },
          },
        )
      }
    
      const [iso2, setIso2] = React.useState('IL')
      const handleSubmit = async (
        values: RegisterValues,
        actions: FormikHelpers<RegisterValues>,
      ) => {
        const phoneUtil = PhoneNumberUtil.getInstance()
        const parsedNumber = phoneUtil.parseAndKeepRawInput(values.phone, iso2)
        const isValid = phoneUtil.isValidNumber(parsedNumber)

        if (!isValid) {
          actions.setFieldError('phone', 'Phone Number is Invalid')
          return
        }

        mutation.mutate(
          { referral: localStorage.getItem('referral'), ...values },
          {
            onSuccess(data) {
              setVerificationData({
                phone: {country_code: data.country_code, number: data.phone},
                email: data.email
              })
              setShouldVerify(true)
              setShowButton(false);
              localStorage.removeItem('referral')
              event('signup');
              track({ event_name: "signup_completed", metadata: {user_id: data.id} });
              fbq.event('CompleteRegistration', { content_name: values.first_name })

              // ✅ auto-login immediately after register
              // login(
              //   values.email, // or values.phone if backend expects identifier
              //   values.password,
              //   actions.setFieldError,
              //   () => {
              //     setIsOpen(false) // close modal
              //     setCurrentView('login') // reset modal view
              //     setProductType(null)
              //     setPortLoginCallBack(undefined)
              //     executePostLoginCallback?.() // continue checkout/personalization flow
              //   },
              //   setVerificationError,
              //   setVerificationData,
              //   setProductType
              // )
            },
            onError(error: any) {
              if (error.response?.data?.message === 'Phone Number already Exists') {
                actions.setFieldError('phone', error.response.data.message)
              } else if (error.response?.data?.message === 'The email has already been taken.') {
                actions.setFieldError('email', error.response.data.message)
              } else {
                actions.setFieldError('first_name', error.response.data.message)
              }

              toast.custom(
                (t) => (
                  <CustomToast t={t} message={error.response.data.message} type="error" />
                ),
                { duration: 4000, id: 'Registration Error' }
              )
            },
          }
        )
      }
    
      const ref = useRef(null)

      return (
        <div className="modal-content p-3 pb-0 lg:pb-0 xl:pb-0 2xl:pb-0 lg:p-6 xl:p-8 2xl:p-11 pt-0 lg:pt-0 xl:pt-0 2xl:pt-0">
                          <AnimatePresence>
                            <motion.div
                              initial={{opacity: 0, translateX: '10%'}}
                              transition={{type: 'spring', duration: 0.5}}
                              animate={{opacity: 1, translateX: '0'}}
                              exit={{opacity: 0, translateX: '10%'}}>
                              {verificationData && shouldVerify ? (
                                <Verifications
                                  phone={verificationData.phone}
                                  email={verificationData.email}
                                  fromRegister={true}
                                  setShouldVerify={setShouldVerify}
                                  setVerificationData={setVerificationData}
                                  setIsOpen={setIsOpen}
                                  postLoginCallBack={postLoginCallBack}
                                  setPortLoginCallBack={setPortLoginCallBack}
                                  executePostLoginCallback={executePostLoginCallback}
                                  setCurrentView={setCurrentView}
                                  showButton={showButton}
                                  setShowButton={setShowButton}
                                />
                              ) : (
                                <>
                                  <AnimatePresence>
                                    <motion.div
                                      initial={{opacity: 0, translateX: '10%'}}
                                      transition={{type: 'spring', duration: 0.5}}
                                      animate={{opacity: 1, translateX: '0'}}
                                      exit={{opacity: 0, translateX: '10%'}}>
                                      <>
                                        <Formik
                                          initialValues={{
                                            first_name: '',
                                            last_name: '',
                                            email: '',
                                            phone: '',
                                            password: '',
                                            country_code: '+971',
                                          }}
                                          innerRef={ref}
                                          validationSchema={RegisterSchema}
                                          validateOnChange={false}
                                          validateOnBlur={false}
                                          onSubmit={handleSubmit}>
                                          {({
                                            errors,
                                            touched,
                                            values,
                                            setFieldValue,
                                            setFieldError,
                                          }) => (
                                            <RegisterForm
                                              errors={errors}
                                              touched={touched}
                                              values={values}
                                              setFieldValue={setFieldValue}
                                              setFieldError={setFieldError}
                                              ResendMutation={ResendMutation}
                                              ResendEmailMutation={ResendEmailMutation}
                                              mutation={mutation}
                                              setIso2={setIso2}
                                              onButtonClick={onButtonClick} // Pass the handler to child components
                                            />
                                          )}
                                        </Formik>
                                      </>
                                    </motion.div>
                                  </AnimatePresence>
                                </>
                              )}
                            </motion.div>
                          </AnimatePresence>
                        </div>
      )
}

export default RegisterView;

function RegisterForm({
  errors,
  touched,
  setFieldError,
  setFieldValue,
  setIso2,
  values,
  mutation,
  ResendMutation,
  ResendEmailMutation,
  onButtonClick // Add this prop
}: any) {
  const {t: tCommon} = useTranslation('common');
  const {locale} = useRouter();
  const hasStartedRef = useRef(false)

  React.useEffect(() => {
    const hasAnyValue =
      values.first_name?.trim() ||
      values.last_name?.trim() ||
      values.email?.trim() ||
      values.phone?.trim() ||
      values.password?.trim();

    if (hasAnyValue && !hasStartedRef.current) {
      hasStartedRef.current = true; // mark immediately
      event("signup_form_started");
      track({ event_name: "signup_started" });
    }
  }, [values.first_name, values.last_name, values.email, values.phone, values.password]);
  return (
    <Form>
      <div className={`col lg:flex ${locale === 'ar' ? 'flex-row' : 'flex-row-reverse'}`} id='register-form'>
        <div className="form-group flex flex-col mt-3 w-full">
          <TextInput
            label={`${tCommon('nameLabel')}`}
            type="text"
            name="first_name"
            placeholder={`${tCommon('namePlaceholder')}`}
            isError={errors.first_name && touched.first_name}
            error={errors.first_name}
            dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}
          />
        </div>
        <div className={`form-group flex flex-col mt-3 w-full ${locale === 'ar' ? 'lg:mr-4' : 'lg:ml-4'}`}>
          <TextInput
            label={`${tCommon('lastNameLabel')}`}
            type="text"
            name="last_name"
            placeholder={`${tCommon('lastNamePlaceholder')}`}
            isError={errors.last_name && touched.last_name}
            error={errors.last_name}
            dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}
          />
        </div>
      </div>

      <div className="form-group flex flex-col mt-3" dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}>
        <PhoneInput
          values={values}
          setFieldError={setFieldError}
          setFieldValue={setFieldValue}
          setIso2={setIso2}
          isError={errors.phone && touched.phone}
          error={errors.phone}
          label={`${tCommon('phoneLabel')}`}
        />
      </div>
      <div className="form-group flex flex-col mt-3">
        <TextInput
          label={`${tCommon('emailLabel')}`}
          type="email"
          name="email"
          placeholder={`${tCommon('emailPlaceholder')}`}
          isError={errors.email && touched.email}
          error={errors.email}
          dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}
        />
      </div>
      <div className="form-group flex flex-col mt-3">
        <TextInput
          label={`${tCommon('passwordLabel')}`}
          type="password"
          name="password"
          placeholder={`${tCommon('registerPasswordPlaceholder')}`}
          isError={errors.password && touched.password}
          error={errors.password}
          dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}
        />
      </div>

      <SubmitButton
        text={`${tCommon('resgisterSubmit')}`}
        isLoading={mutation.isLoading || ResendMutation.isLoading || ResendEmailMutation.isLoading}
        textType="string"
      />
    </Form>
  )
}